import React, { useState } from 'react';
import MainLayout from '../../components/layouts/MainLayout';
import AddressList from '../../components/profile/AddressList';
import AddressForm from '../../components/profile/AddressForm';
import Button from '../../components/common/Button';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import { useAddresses } from '../../hooks/useAddresses';
import { theme } from '../../config/theme';
import { PlusIcon } from '../../components/icons/Icons';

const Addresses = () => {
  const { addresses, loading, addAddress, updateAddress, deleteAddress, setDefaultAddress } = useAddresses();
  const [showForm, setShowForm] = useState(false);
  const [editingAddress, setEditingAddress] = useState(null);

  const handleAdd = () => {
    setEditingAddress(null);
    setShowForm(true);
  };

  const handleEdit = (address) => {
    setEditingAddress(address);
    setShowForm(true);
  };

  const handleSubmit = async (data) => {
    if (editingAddress) {
      return await updateAddress(editingAddress.id, data);
    } else {
      return await addAddress(data);
    }
  };

  const handleClose = () => {
    setShowForm(false);
    setEditingAddress(null);
  };

  if (loading && addresses.length === 0) return <LoadingSpinner fullScreen />;

  return (
    <MainLayout>
      <div style={{ padding: theme.spacing.xl, maxWidth: '1000px', margin: '0 auto' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: theme.spacing.xl }}>
          <h1 style={{ 
            fontSize: theme.typography.fontSize['3xl'], 
            fontWeight: theme.typography.fontWeight.bold 
          }}>
            My Addresses
          </h1>
          <Button onClick={handleAdd}>
            <PlusIcon size={20} />
            Add Address
          </Button>
        </div>

        <AddressList
          addresses={addresses}
          onEdit={handleEdit}
          onDelete={deleteAddress}
          onSetDefault={setDefaultAddress}
        />

        <AddressForm
          isOpen={showForm}
          onClose={handleClose}
          address={editingAddress}
          onSubmit={handleSubmit}
          loading={loading}
        />
      </div>
    </MainLayout>
  );
};

export default Addresses;